<template>
  <div class="vue-view vue-view--teams-overview view-plantjesweekend-actions">
    <slot name="filters">
      <div class="vue-view__filters view-filters">
        <form class="views-exposed-form">
        <h5 class="filters--label">Verfijnen</h5>
        <div class="filters__form filters--groups form--inline clearfix">
          <div class="geolocation-geocoder-google-geocoding-api">
          <div class="filters__filter form-item js-form-item">
            <label>{{
              Drupal.t(
                "Postcode of gemeente",
                {},
                { context: "VueJs Teams search" }
              )
            }}</label>
            <div class="filter-city-wrapper">
              <FormInput
                @change="onCityChange"
                @input="onCityChange"
                :value="model.filter.city"
                class="form-control"
                :required="false"
                autocomplete="off"
              />
              <div class="action-lookup-wrapper" v-if="searchCities.length">
                <div class="action-lookup-results">
                  <ul class="list-angle">
                    <li
                        v-for="city in searchCities"
                        :key="city.postalcode"
                        @click="selectCity(city)"
                        class="action-lookup-result"
                    >
                      <a href="#" @click.prevent>{{ city.postalcode }} {{ city.city }}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          </div>

          <div class="filters__filter form-item js-form-item">
            <SelectFilter
              :list="this"
              name="distance"
              :label="Drupal.t('Distance')"
              :value="model.filter.distance"
              :options="config.distances"
              @change="onDistanceChange"
            />
          </div>

          <div class="filters__filter form-item js-form-item">
            <SelectFilter
              :list="this"
              name="date"
              :label="Drupal.t('Date')"
              :value="model.filter.date"
              :options="config.dates"
              @change="onDateChange"
            />
          </div>

          <div class="form-actions" id="edit-actions">
            <Spinner v-if="loading" />
            <button
              v-if="!loading"
              type="button"
              class="button js-form-submit form-submit btn-primary btn"
              @click="applyFilters()"
            >{{ Drupal.t("Search") }}</button>
          </div>
        </div>
        </form>
      </div>
    </slot>

    <div v-if="error">
      <div class="alert alert-danger">{{ error }}</div>
    </div>

    <div class="row">
      <div class="attachment attachment-before col-12" :ref="listId">
        <div class="views-element-container">
          <div class="view view-plantjesweekend-actions">
            <div class="view-content">
              <div class="geolocation-map-wrapper">
                <GoogleMap
                  :api-key="config.googleMapsApiKey"
                  style="width: 100%; height: 600px"
                  :center="config.mapCenter"
                  :zoom="9"
                >
                  <MarkerCluster>
                    <Marker
                      v-for="(location, i) in mapResults"
                      :key="i"
                      :options="{
                        position: {
                          lat: location.field_address_geo.lat,
                          lng: location.field_address_geo.lon,
                        },
                      }"
                    >
                      <InfoWindow :options="{ minWidth: 300 }"
                        ><PwPos :pos="location"
                      /></InfoWindow>
                    </Marker>
                  </MarkerCluster>
                </GoogleMap>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="vue-view__content view-content view__left col-md-8"
        :ref="listId + '__content'"
      >
        <Spinner v-if="loading" />
        <div v-if="loaded && !loading && !error">
          <div class="vue-view__results">
            <div v-if="!count">
              <div class="alert alert-info">
                {{
                  Drupal.t(
                    "No locations were found.",
                    {},
                    { context: "VueJs Teams search" }
                  )
                }}
              </div>
            </div>

            <div v-else>
              <h3 class="view__title">Verkoop op een vaste plaats</h3>
              <template v-for="row in locResults" :key="row">
                <div class="views-row" :data-id="row.drupal_internal__id">
                  <PwPos :pos="row" />
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div class="attachment attachment-after view__right col-md-4" :ref="listId + '__d2d'">
        <div class="views-element-container">
          <div
            class="view view-plantjesweekend-actions view-id-plantjesweekend_actions view-display-id-door2door_overview_block list-overview"
          >
            <h3 class="view__title">Verkoop deur aan deur</h3>
            <div class="view-content" :ref="listId + '___d2d'">
              <template v-for="city in d2dResults" :key="city">
              <div class="view-grouping">
                <div class="view-grouping-header">{{ city.name }}</div>
                <div class="view-grouping-content">
                  <template v-for="location in city.locations.values()" :key="location">
                    <h6>{{ location.field_d2d_neighbourhood }}</h6>
                    <div class="views-row">
                      <PwPos :pos="location" />
                    </div>
                  </template>
                </div>
              </div>
            </template>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { DrupalJsonApiParams } from "drupal-jsonapi-params";
import FormInput from "@/components/Form/FormInput.vue";
import { parse } from "qs";
import Spinner from "@/components/General/SpinnerComponent.vue";
import PwPos from "@/components/General/PwPos.vue";
import SelectFilter from "@/components/Filters/SelectFilter.vue";
import { GoogleMap, MarkerCluster, Marker, InfoWindow } from "vue3-google-map";
import cities from '../../data/cities.json';

export default {
  name: "PwPosOverview",
  components: {
    Spinner,
    FormInput,
    SelectFilter,
    GoogleMap,
    Marker,
    InfoWindow,
    MarkerCluster,
    PwPos,
  },
  props: {
    actionId: null,
    filters: {},
  },
  data() {
    // Parse our model from the visible query string.
    const queryString = this.$window.location.search.split("?")[1] || "";
    const model = parse(queryString);

    return {
      listId: "pos",
      path: this.$window.location.pathname,
      model: {
        filter: model.filter || { date: "all", distance: "10", city: "" },
      },
      config: {
        distances: [
          { value: "all", label: "- Alle -" },
          { value: "10", label: "10 km" },
          { value: "20", label: "20 km" },
          { value: "50", label: "50 km" },
        ],
        dates: [
          { value: "all", label: "- Alle -" },
          { value: "14/09/2026", label: "Ma 14 sep 2026" },
          { value: "15/09/2026", label: "Di 15 sep 2026" },
          { value: "16/09/2026", label: "Wo 16 sep 2026" },
          { value: "17/09/2026", label: "Do 17 sep 2026" },
          { value: "18/09/2026", label: "Vr 18 sep 2026" },
          { value: "19/09/2026", label: "Za 19 sep 2026" },
          { value: "20/09/2026", label: "Zo 20 sep 2026" },
        ],
        isMobile: false,
        mapCenter: {
          lat: 50.9337253319313,
          lng: 3.9469820192924283,
        },
        googleMapsApiKey: "AIzaSyAh8d81-NjYLmArNOy1PhjzSJlW34n8zCU",
      },
      resource: null,
      d2dResource: null,
      Drupal: this.$drupal,
      loading: false,
      loaded: false,
      needsRefresh: false,
      error: false,
    };
  },
  computed: {
    searchCities(e) {
      if (this.model.filter?.city === '' || this.model.filter?.city.length < 2) {
        return []
      }

      let matches = 0

      return cities.cities.filter(city => {
        if (city?.city.toLowerCase().includes(this.model.filter?.city.toLowerCase()) && matches < 10) {
          matches++
          return city
        }
        if (city?.postalcode.toString().startsWith(this.model.filter?.city.toLowerCase()) && matches < 10) {
          matches++
          return city
        }
      })
    },
    /**
     * Return the count of keys in our filter object.
     *
     * @returns {boolean}
     */
    hasActiveFilters() {
      let hasValues = false;
      for (const filterKey in this.model.filter) {
        if (filterKey in this.model.filter) {

          const filterValues = this.model.filter[filterKey];

          if (
            (Array.isArray(filterValues) || this.$helpers.isString(filterValues)) &&
            filterValues.length
          ) {
            hasValues = true;
          }
        }
      }

      return hasValues;
    },

    /**
     * The total item count.
     *
     * @type {int}
     */
    count() {
      return parseInt(((this.resource || {}).meta || {}).count) || 0;
    },

    /**
     * Our resource results.
     *
     * @type {object[]}
     */
    results() {
      return (this.resource || {}).data || [];
    },

    /**
     * Our resource results.
     *
     * @type {object[]}
     */
    mapResults() {
      return ((this.resource || {}).data || []).filter(
        (pos) => pos?.field_address_geo?.lat
      );
    },

    /**
     * Our resource results.
     *
     * @type {object[]}
     */
    locResults() {
      return ((this.resource || {}).data || []).filter(
        (pos) => !pos?.field_location_type || pos?.field_location_type == 'location'
      );
    },

    /**
     * Our resource results.
     *
     * @type {object[]}
     */
    d2dResults() {
      const d2dPos = ((this.resource || {}).data || []).filter(
        (pos) => pos?.field_location_type && pos?.field_location_type == 'd2d' && pos?.field_d2d_city
      );

      let cities = new Map();

      d2dPos.forEach(pos => {

        if (!pos.field_d2d_city || pos.field_d2d_city == '') {
          return;
        }

        if (!cities.has(pos.field_d2d_city)) {
          cities.set(pos.field_d2d_city, {
            name: pos.field_d2d_city,
            locations: new Map(),
          });
        }

        let city = cities.get(pos.field_d2d_city);
        let neighbourhood = city.locations.get(pos.field_d2d_neighbourhood);
        if (neighbourhood) {
          neighbourhood.field_timeslots = pos.field_timeslots.concat(neighbourhood.field_timeslots)
        }
        else {
          city.locations.set(pos.field_d2d_neighbourhood, pos);
        }
      });

      const sortedMap = new Map([...cities.entries()].sort())
      return sortedMap.values();
    },

  },
  methods: {
    /**
     * Vuex actions.
     */
    ...mapActions("pos", ["getResults"]),
    /**
     * Handle distance filter change.
     *
     * @param {Object} value
     */
    onDistanceChange(value) {
      if (value === "") {
        value = "10";
      }

      this.model.filter = Object.assign({}, this.model.filter, {
        distance: value,
      });
    },

    /**
     * Handle date filter change.
     *
     * @param {Object} value
     */
    onDateChange(value) {
      if (value === "") {
        value = "all";
      }

      this.model.filter = Object.assign({}, this.model.filter, {
        date: value,
      });
    },

    /**
     * Handle city filter change.
     *
     * @param {Object} value
     */
    onCityChange(value) {
      this.model.filter = Object.assign({}, this.model.filter, {
        city: value,
      });
    },

    selectCity(city) {
      this.model.filter = Object.assign({}, this.model.filter, {
        city: city.postalcode + ' ' + city.city,
      });
    },

    /**
     * Build the visible query string from our model.
     */
    async resetFilters() {
      this.model = {
        filter: { distance: "10", date: "all", city: "" },
      };

      if (this.config.isMobile) {
        this.setModelToQueryString();

        await this.$fetch();
      }
    },

    /**
     * Fetch JSON:API results.
     *
     * @param {Object} settings
     */
    async fetchData(settings) {
      const query = this.getQuery(settings);
      this.loading = true;
      this.getResults({
        actionId: "pw",
        query: query,
      })
        .then((resource) => {
          this.resource = resource;
          this.loading = false;
          this.loaded = true;
        })
        .catch((error) => {
          this.error = Drupal.t(
            "Could not load the locations.",
            {},
            { context: "VueJs Teams search" }
          );
          this.loaded = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onWindowResize(event) {
      this.config.isMobile = this.$helpers.isMobile();
    },

    /**
     * Scroll to the top of the application.
     */
    scrollToTop() {
      const element = this.$refs[this.listId + "__content"];
      const top = element.offsetTop;

      window.scrollTo(0, top);
    },

    /**
     * Builds the query for the JSON:API request.
     *
     * @param {object} settings - The merged module and component settings object.
     *
     * @return {DrupalJsonApiParams}
     */
    getQuery(settings = {}) {
      const query = new DrupalJsonApiParams();

      // Filters.
      if (this.model.filter.city) {
        query.addFilter("city", this.model.filter.city);
      }
      if (this.model.filter.distance && this.model.filter.distance !== 'all') {
        query.addFilter("distance", this.model.filter.distance);
      }
      if (this.model.filter.date && this.model.filter.date !== 'all') {
        query.addFilter("date", this.model.filter.date);
      }

      return query.getQueryObject();
    },

    /**
     * Wrapper for fetchData.
     *
     * @returns {Promise<*>}
     */
    async $fetch() {
      // Fetch resource.
      if (this.fetchData) {
        try {
          await this.fetchData.call(this, {});
        } catch (err) {
          // Build error details.
          const title =
            (err.response || {}).statusText ||
            ((((err.response || {}).data || {}).errors || [])[0] || {}).title;
          const summary = (err.response || {}).status
            ? [(err.response || {}).status, title].filter((s) => s).join(": ")
            : err.message;

          console.log(title, summary);

          return false;
        }
      }
    },

    /**
     * Filters update event handler.
     */
    onFiltersUpdate() {
    },

    /**
     * Set the publicly visible query parameters.
     *
     * @param {object} query
     */
    setQueryParams(query) {
      this.$router.push({ path: this.path, query: query });
    },

    /**
     * Build the visible query parameters object.
     *
     * @returns {{filter, page, sort}}
     */
    buildQueryParams() {
      return this.model;
    },

    /**
     * Build the visible query string from our model.
     */
    setModelToQueryString() {
      this.setQueryParams(this.buildQueryParams());
    },

    /**
     * Filter on the selected model values.
     */
    async applyFilters() {
      // Reset paging.
      this.onFiltersUpdate();

      this.setModelToQueryString();

      await this.$fetch();
    },
  },
  watch: {
    // "model.filter": {
    //   deep: true,
    //   async handler(to, from) {
    //     if (this.config.isMobile) {
    //       return;
    //     }

    //     // Reset paging.
    //     this.onFiltersUpdate();

    //     this.setModelToQueryString();

    //     await this.$fetch();
    //   },
    // },
  },
  mounted() {
    this.$fetch();
  },
  created() {
    window.addEventListener("resize", this.onWindowResize);
    this.onWindowResize();
  },
  unmounted() {
    window.removeEventListener("resize", this.onWindowResize);
  },
};
</script>
